import styled from "styled-components";
import {VouchersGamesListTitleDefaultBox} from "./voucher-games-list-title.default.box";

export const VouchersGamesListTitleCasino777Box = styled(VouchersGamesListTitleDefaultBox)`
    border-top: 1px solid transparent;
    padding-top: 1.2rem;
`;
